import { render, staticRenderFns } from "./FreeGifts.vue?vue&type=template&id=0aec3a66&scoped=true&"
import script from "./FreeGifts.vue?vue&type=script&lang=ts&"
export * from "./FreeGifts.vue?vue&type=script&lang=ts&"
import style0 from "./FreeGifts.vue?vue&type=style&index=0&id=0aec3a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aec3a66",
  null
  
)

export default component.exports